import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['zipcodeForm', 'clientForm', 'resultsContainer', 'tabZipcode', 'tabClient']

  showZipcode() {
    if (this.hasResultsContainerTarget) {
      this.resultsContainerTarget.classList.add('hidden')
    }
    this.zipcodeFormTarget.classList.remove('hidden')
    this.clientFormTarget.classList.add('hidden')
    this.setActiveTab('zipcode')
    this.resetZipcodeForm()
  }

  showClient() {
    if (this.hasResultsContainerTarget) {
      this.resultsContainerTarget.classList.add('hidden')
    }
    this.zipcodeFormTarget.classList.add('hidden')
    this.clientFormTarget.classList.remove('hidden')
    this.setActiveTab('client')
    this.resetClientForm()
  }

  setActiveTab(which) {
    if (!this.hasTabZipcodeTarget || !this.hasTabClientTarget) return
    const activeClasses = ['border-indigo-500', 'text-indigo-600']
    const inactiveClasses = ['border-transparent', 'text-gray-500', 'hover:border-gray-300', 'hover:text-gray-700']
    if (which === 'zipcode') {
      this.tabZipcodeTarget.classList.remove(...inactiveClasses)
      this.tabZipcodeTarget.classList.add(...activeClasses)
      this.tabZipcodeTarget.setAttribute('aria-selected', 'true')
      this.tabClientTarget.classList.remove(...activeClasses)
      this.tabClientTarget.classList.add(...inactiveClasses)
      this.tabClientTarget.setAttribute('aria-selected', 'false')
    } else {
      this.tabClientTarget.classList.remove(...inactiveClasses)
      this.tabClientTarget.classList.add(...activeClasses)
      this.tabClientTarget.setAttribute('aria-selected', 'true')
      this.tabZipcodeTarget.classList.remove(...activeClasses)
      this.tabZipcodeTarget.classList.add(...inactiveClasses)
      this.tabZipcodeTarget.setAttribute('aria-selected', 'false')
    }
  }

  resetZipcodeForm() {
    const form = this.zipcodeFormTarget.querySelector('form')
    if (form) form.reset()
    const categoryAmountsEl = this.zipcodeFormTarget.querySelector('[data-controller*="category-amounts"]')
    if (categoryAmountsEl) {
      const controller = this.application.getControllerForElementAndIdentifier(categoryAmountsEl, 'category-amounts')
      if (controller && typeof controller.reset === 'function') controller.reset()
    }
  }

  resetClientForm() {
    const form = this.clientFormTarget.querySelector('form')
    if (form) form.reset()
    const quoteCalculator = this.application.getControllerForElementAndIdentifier(this.element, 'quote-calculator')
    if (quoteCalculator && typeof quoteCalculator.clearSelection === 'function') quoteCalculator.clearSelection()
  }
}
